// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2Dj7C","col":"CardReaderDesc_col__2BclF","label":"CardReaderDesc_label__3N3ZV"};